export const kokymbaeva = {
    id: "kokymbaeva",
    name: { ru: "Кокумбаева Айгерим Бейбитжанкызы", kz: "Қоқымбаева Айгерім Бейбітжанқызы" },
    position: { ru: "Медсестра, 2 категория", kz: "Мейіргер, 2-санат" },
    department: "nursing",
    image: "/team_photoes/new/Айгерім Бейбітжанқызы.svg",
    experience: {
      ru: "11 лет",
      kz: "11 жыл"
    },
    education: {
      ru: `Учебное заведение: ГКП на ПХВ Медицинский колледж акимата г. Астаны
Год окончания: 2015
Специальность: Общая медсестра`,
      kz: `Оқу орны: Астана қ. әкімдігінің ШЖҚ ПХВ Медициналық колледжі
Бітіру жылы: 2015
Мамандығы: Жалпы мейірбике`
    },
    specialization: {
      ru: "Сестринское дело",
      kz: "Мейірбике ісі"
    },
        work: {
    ru: `• 2014 — 2021 — Работа в 2 ГДБ (хирургия).
• 2021 — 2022 — Работа в Инвиво.
• 2022 — 2025 — Спортивный медицинский центр (должность: медсестра лаборатории).`,
    kz: `• 2014 — 2021 — 2 ҚБА-да жұмыс (хирургия).
• 2021 — 2022 — Инвиво-да жұмыс.
• 2022 — 2025 — Спорттық медициналық орталық (лауазым: зертхана мейірбикесі).`,
  },
certificates: {
    ru: '',
    kz: '',
  }
  };
